// OpenSearch 이메일 검색 서비스 (OFM-212)
import { openSearchApiClient } from 'myNet'

import type { OpenSearchRequest, OpenSearchResponse } from './types'

export * from './types'

/**
 * OpenSearch 이메일 검색. JWT subject(본인 계정) 기준으로 자동 스코프된다.
 * 빈 body는 최근 메일을 반환한다.
 */
export async function searchEmails(req: OpenSearchRequest): Promise<OpenSearchResponse> {
  const { data } = await openSearchApiClient.post<OpenSearchResponse>('/search', req)
  return data
}

export default {
  searchEmails,
}
